//@flow
import _ from 'lodash';
// app
import ko from 'rgs-knockout';
import type { PureComputed } from 'rgs-knockout';
// rgs-nfd-ui-kit
import { withProps } from './../../../helpers';

import {
	DEFAULT_DROPDOWN_pathToID,
	DEFAULT_DROPDOWN_pathToName,
} from 'rgs-nfd-ui-kit/ko-components/dropdown/contracts';
import type { DropdownFilterDefaultItem } from 'rgs-nfd-ui-kit/components/filter/filters/dropdown';

export type TDropdownListDefaultItem = {
	[string]: any
}

export class DropdownList {
	onChange: (any) => void;

	props: {
		items: PureComputed<*[]>
	};
	_options: any;

	constructor (options: *) {
		this._options = options;

		const {
			btnMoreClick = () => undefined,
			btnMoreContent = 'Показать ещё',
			btnMoreIsShow = ko.observable(false),
			onChange = _.noop,
			items = [],
			scrollable,
		} = withProps(options);

		this._pathToID = _.get(options, 'props.pathToID', DEFAULT_DROPDOWN_pathToID);
		this._pathToName = _.get(options, 'props.pathToName', DEFAULT_DROPDOWN_pathToName);
		this.currentValueID = _.get(options, 'props.currentValueID', ko.observable());

		this.onChange = onChange;
		this.btnMoreClick = btnMoreClick;
		this.btnMoreContent = btnMoreContent;
		this.btnMoreIsShow = btnMoreIsShow;

		this.items = ko.pureComputed(() => {
			return ko.unwrap(items);
		});

		this.items.subscribe((newValue: any) => {
			const currentID = ko.unwrap(this.currentValueID);
			if (this._pathToID && currentID) {
				const newCurrentValue = _.find(newValue, (item: any) => {
					return this.getItemID(item) === currentID;
				});
				this._options.props.currentValue(newCurrentValue);
			}
		});

		this.props = {
			items: this.items,
			onItemClick: this.handleClickByItem,
			classNames: {
				'nfd-dropdown-scrollable': scrollable,
			},
		};
	}

	handleClickByItem = (item: any): void => {
		this.onChange(item);
	};

	getItemID = (item: DropdownFilterDefaultItem): number | string => {
		return _.get(item, this._pathToID || DEFAULT_DROPDOWN_pathToID);
	};

	getItemName = (item: DropdownFilterDefaultItem): string => {
		return _.get(item, this._pathToName || DEFAULT_DROPDOWN_pathToName);
	};
}
